// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const qrCodeSchema = z.object({
  entryPointType: z.enum(["QR_CODE"]),
  sessionId: z.string(),
  state: z.string(),
  type: z.enum(["VANCE_QR_CODE"]),
  workspaceId: z.string(),
});
